module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_online@2x-241f1fb6db4817218f7711bf85c3c2a1.webp";